import React from 'react'
import { Sparkle, CaretRight } from '@phosphor-icons/react'
import { useRouter } from 'next/router'
import { motion } from 'motion/react'
import useNavigation from 'src/lib/hooks/useNavigation'
import { useLocale } from 'src/lib/hooks/useLocal'
import { classNames } from 'src/lib/utils/helpers'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'
import { Icon } from '@shopflo/ui'

interface ExploreMoreProps {
  text: string
  id?: string
}

export const ExploreMore: React.FC<ExploreMoreProps> = ({ text, id }) => {
  const {
    actions: { toggleAndRedirect }
  } = useNavigation()
  const { t } = useLocale()

  const { canAccess } = useUser()

  const hasAppStoreAccess = canAccess(permissionType.TAB_APP_STORE, 0)

  return (
    <motion.div layout className='p-3 border-t-1 border-gray-200'>
      <div className='flex flex-col gap-2 text-xs text-blue-600 '>
        <Sparkle size={20} className='text-zinc-500' />
        <div className='flex flex-col'>
          <span className='text-zinc-500 leading-[18px] font-normal text-xs'>{text}</span>
          <p
            id={id}
            className={classNames(
              'text-zinc-600 font-semibold text-text-xs-medium gap-0.5 flex items-center cursor-pointer',
              !hasAppStoreAccess ? 'opacity-50 !cursor-not-allowed' : ''
            )}
            onClick={() => hasAppStoreAccess && toggleAndRedirect('/apps-integrations')}
            aria-disabled={!hasAppStoreAccess}
          >
            <span className='text-xs'>{t('billing.explore')}</span>
            <span className='text-zinc-500'>
              <Icon IconComponent={CaretRight} size='xxs' className='text-zinc-500' weight='bold' />
            </span>
          </p>
        </div>
      </div>
    </motion.div>
  )
}
